module.exports = __webpack_public_path__ + "img/cert4.8b6744d6.png";